( function( $, window, undefined ) {
    
    var initialWindowSize = window.innerWidth;
    var animateSpeed = 300;
    var initialPosition = '8%';
    var movePosition = '35%';        
    
    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var parentNavLinks = [];
    
    $(document).ready(function () {
        
        if( $( '.askExpertFormContainer' ).length > 0){
                    
            $('.input__field').change(function () {
                var $this = $(this);
                var $thisInput = $this.find('input');
                if ($this.val() !== "") {
                    $this.addClass('input--filled');
                } else {
                    $this.removeClass('input--filled');
                }
            });

            // We need to move the 'label' that CF7 generates into the main span wrapper so that the 'hoshi' styling works!
            var spans = document.getElementsByClassName("wpcf7-form-control-wrap");

            for( var i=0 ; i < spans.length ; i++ ) {

                var input = spans[i].nextSibling;

                if( input != null ){

                    if( input.tagName == "LABEL" ){

                        spans[i].appendChild( input );

                    }

                }

            }
            
        }
        
        $('body').on('click', '.expertCheckBoxHolder', function () {
                        
            $(this).toggleClass('active');

            var checkBox = $(this).closest('.expertCustomCheckBox').find('.wpcf7-list-item label input[type=checkbox]');

            console.log( checkBox.is(':checked') );

            var isChecked = checkBox.is(':checked');
                        
            if (isChecked) {
                checkBox.attr("checked", false);
            } else {
                checkBox.attr('checked', true);
            }

        });
        
        // Check for any click on the custom checkbox label.
        $('.expertCustomCheckBox label').on("click", function( evt ){                                           
                                   
            evt.preventDefault();
            
//            if( evt.target.tagName === "INPUT"){
//                            
//                if( $( ".expertCheckBoxHolder" ).length > 0 ){
//
//                    $( ".expertCheckBoxHolder" ).toggleClass('active');
//
//                }
//                
//            }
            
        });
        
        $( '.askExpertTrigger' ).on( 'click', function( evt ){
            
            evt.preventDefault();
            
            $( '.askExpertContainer' ).addClass( "open");
            $( '.askExpertTrigger' ).hide();
            $( '.askExpertCloseTrigger' ).fadeIn( "slow").css("display","inline-block");;
            
            setTimeout(function(){$( '.askExpertFormContainer' ).hide().fadeIn( 'slow' );}, 500);
            
        });
        
        $( '.askExpertCloseTrigger' ).on( 'click', function( evt ){
            
            evt.preventDefault();
            
            $( '.askExpertFormContainer' ).hide();
            
            $( '.askExpertContainer' ).removeClass( "open");
            $( '.askExpertCloseTrigger' ).hide();
            $( '.askExpertTrigger' ).fadeIn( "slow").css("display","inline-block");;
            
            setTimeout(function(){}, 500);
            
        });
        
        $('#nav li a').bind('touchstart', function(event){        

            if (viewport() > 1023) {

                event.preventDefault();
                event.stopPropagation(); /*Make all touch events stop at the .filters ul.children container element*/                       

                if($(this).parent().has('ul').length){ // Check if the element has a sub-nav

                    var linkToGo = $(this).closest('a').attr('href');

                    // if we have a sub-nav then first add it to the array to keep track, then check if it exists, if so then go to the link (if it has one)
                    if(parentNavLinks.indexOf(linkToGo) !== -1){
                        location.href = linkToGo;
                    }else{
                        parentNavLinks.length = 0; //reset the array first so that the user can go back to the other drop downs
                        parentNavLinks.push(linkToGo);
                    }

                }else{
                    var linkToGo = $(this).closest('a').attr('href');
                    location.href = linkToGo;
                }

            }

        });

        $('.clickToGo').on('click', function(){

            var gotoLink = $(this).data('goto-link');

            if(gotoLink != ""){
                location.href = gotoLink;
            }

        });
        
        $( '.cookieLink' ).on( 'click', function(){
                      
           location.href = '/cookie-policy';
            
        });
        
        $('.tabButton').click(function(){
            
            var parent = $(this).closest('.approachCarouselContainer');
            
            parent.find('.tabButton').removeClass('active');
            
            $(this).addClass('active');
            
            parent.find('.carouselItem').removeClass('active');
            parent.find('.' + $(this).data('index')).addClass('active');
            
        });

        $('.noLink').click(function(e){
            e.preventDefault();
        });

        adjustBlocks();

        $('.video_click_class').click(function(){

            var iframe =  $(this).closest('.relative').find('iframe');

            $(this).css('display', 'none');

            var player = new Vimeo.Player(iframe);

            player.play().then(function() {

                //console.log('video played')

            }).catch(function(error) {
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                    }
            });	

        });

        $('.Professionalservice .breadcrumb, .Performingart .breadcrumb, .Education .breadcrumb').prependTo(".allStripes");

        $('body').on('click', '.preventDefault', function(e){
            e.preventDefault();
        });

        //switchOdds(viewport());
        //switchFooter(viewport());

        placeNav();

        //mainCarousel();

        $('body').on('click', '.hamburger', function () {
            $('.mainNav:not(.toggling)').toggleClass('hamburgerActive');
            $(".mainNav:not(.toggling)").addClass('toggling').find('#nav').toggleClass('block').slideToggle(800, function () {
                    $('.mainNav').removeClass('toggling');
            });
        });

        //$( window ).bind('load', function () {              

        appendSpan();

        $('body').on('click', '.plusMinus', function (e) {
                e.preventDefault();
                var el = $(this);

                var navBarParent = el.closest('li.mobileShowPlus');
                if (navBarParent.length) {
                        el.toggleClass('active');
                        toggleNavBar(navBarParent);
                }

        });

        $(document).on('mouseenter', '.darkBG', function () {            
            
            if (viewport() > 1024) {

                $(this).stop(true).animate({
                    'background-color': $(this).data('bgcolor')
                }, animateSpeed);

                $(this).find('.clientLogo').stop(true).fadeOut(animateSpeed);
                $(this).find('.keywords').fadeIn(animateSpeed);

                $(this).find('.clientName').stop(true).animate({
                    opacity: 1,
                    top: movePosition
                }, animateSpeed);

                $(this).find('.intro').stop(true).animate({
                    opacity: 1,
                    bottom: movePosition
                }, animateSpeed);
            }

        });

        $(document).on('mouseleave', '.darkBG', function () {            

            if (viewport() > 1024) {
                $(this).stop(true).animate({
                    'background-color': 'rgba(0, 0, 0, 0.5)'
                }, animateSpeed);

                $(this).find('.clientLogo').fadeIn(animateSpeed);
                $(this).find('.keywords').stop(true).fadeOut(animateSpeed);

                $(this).find('.clientName').stop(true).animate({
                    opacity: 0,
                    top: initialPosition
                }, animateSpeed);

                $(this).find('.intro').stop(true).animate({
                    opacity: 0,
                    bottom: initialPosition
                }, animateSpeed);
            }

        });

        $('body').on('click', '.prevAnimate, .nextAnimate', function () {
            var that = $(this);
            that.addClass('switched');

            setTimeout(function () {
                that.removeClass('switched');
            }, 800);
        });

        $(' #da-thumbs > li ').each( function() { $(this).hoverdir(); } );

        $('.imageBgContainer').hover(function(){
            var $div = $(this);	
            if(!$div.hasClass('firstAnimateOngoing')){
                $div.addClass('go');
                var img = document.createElement('img');
                var photoName = $div.attr('id');
                img.src = '/wp-content/themes/velo/img/animated_icons/'+photoName+'.gif?p' + new Date().getTime();
                //$(img).load(function () {
                    if ($div.hasClass('go')) {
                        $div.css({backgroundImage: "url(" + img.src + ")"});
                    }
                //});
            }
        }, function(){
            var $div = $(this);
            if(!$div.hasClass('firstAnimateOngoing')){
                $div.removeClass('go');
                var photoName = $div.attr('id');
                $div.css({backgroundImage: "url(/wp-content/themes/velo/img/animated_icons/"+photoName+".png)"});
            }
        });
        
        $( '.toggleMute' ).on( 'click', function( evt ){
        
            var closestVideo = $( evt.target ).closest( '.col100').find( '.stdVideoAutoPlay' );
            var closestVimeo = $( evt.target ).closest( '.col100').find( '.stdVimeoAutoPlay iframe' );
            
            // Check which type of video we are trying to mute/un-mute.
            if( $( evt.target).hasClass( 'vimeoVideo' ) ){
                var vidType = 'vimeo';
                toggleVideoMute( closestVimeo.attr('id'), vidType ); 
            }else{
                var vidType = 'video';
                toggleVideoMute( closestVideo.attr('id'), vidType ); 
            }
        
            
            
        });

    });

    $( window ).on('load', function() {
            
        appearInViewport();
        animateGifsOnViewport();
        $( window ).on("resize scroll", function () {
            animateGifsOnViewport();
        });
    });

    $(window).bind('resizeEnd', function () {

        //mainCarousel();
        //rotaterWidth();
        //switchOdds(viewport());
        //switchFooter(viewport());

    });

    //delay resize event so it's only called once
    $(window).resize(function () {
        if (this.resizeTO)
            clearTimeout(this.resizeTO);
        this.resizeTO = setTimeout(function () {
            $(this).trigger('resizeEnd');
        }, 250);

        adjustBlocks();

    });

    $(window).on("resize scroll", function () {
        appearInViewport();
        placeNav();
    });

    function adjustBlocks(){
        if(viewport() <= 1280){
            initialPosition = '4%';
            movePosition = '10%';
            if ($('.halfCol').hasClass('thirdAdapter')) {
                movePosition = '14%';
            }
        }else{
            if ( $( '.halfCol' ).hasClass( 'thirdAdapter' ) ) {
                movePosition = '21%';
            }
        }
    }      

    function toggleNavBar(navBarParent) {
        navBarParent.toggleClass('active');
        navBarParent.find('ul').stop().slideToggle(400, function () {            
        });
    }

    function switchOdds(width) {
        if (width <= 767) {
            $('.reversed:not(.switched) .div2').each(function () {
                $(this).insertBefore($(this).prev('.div1'));
                $(this).closest('.reversed').addClass('switched');
            });
        } else {
            $('.reversed.switched .div1').each(function () {
                $(this).insertBefore($(this).prev('.div2'));
                $(this).closest('.reversed').removeClass('switched');
            });
        }

    }
    
    function switchFooter(width){
                
        if (width <= 767) {
            $('.footerStd:not(.switched) .div2').each(function () {
                $(".social").appendTo(".footerAwards");
                $('.footerStd').addClass('switched');
            });
        }else{
            $('.footerStd.switched .div1').each(function () {
                //$(this).insertBefore($(this).prev('.div2'));
                $(".social").appendTo(".footerStd");
                $('.footerStd').removeClass('switched');
            });
        }

    }

    function appendSpan() {
        var htmlToPrepend = '<div class="plusMinus"><span></span><span></span></div>';
        $('.mobileShowPlus').append(htmlToPrepend);
    }

    function getBodyScrollTop() {
        var el = document.scrollingElement || document.documentElement;
        return el.scrollTop;
    }

    function placeNav() {

        if (getBodyScrollTop() > 30) {
            $('.mainNav, .topMargin').addClass('scrolled');
        } else {
            $('.mainNav, .topMargin').removeClass('scrolled');
        }
    }

    function appearInViewport() {
        
        $('.appear, .leftAppear, .rightAppear').each(function () {                       
            if ($(this).isInViewport()) {
                $(this).addClass('appeared');
            }
        });
        
        // Check if there is a video to autoplay when in/out of view
        if( $( '.stdVideoAutoPlay' ).length > 0 ){
            
            // Now we loop for all those videos we have and check if they are in view or not
            $('.stdVideoAutoPlay').each(function () {
                
                var videoTmpID = $( this ).attr( 'id' );
                var videoEl = document.getElementById( videoTmpID );
                
                if ($(this).isInViewport()) {
                    
                    // If this video element is in view then play
                    $(this)[0].play();
                    
                }else{
                    
                    $(this)[0].pause();
                    
                }
                
            });
            
        }
        
        // Check if there is a vimeo embed to autoplay when in/out of view
        if( $( '.stdVimeoAutoPlay' ).length > 0 ){
            
            // Now we loop for all those videos we have and check if they are in view or not
            $('.stdVimeoAutoPlay').each(function () {
                
                var vimeoIframeID = $( '.stdVimeoAutoPlay' ).find('iframe');

                var vimeoIframeObj = $( '#' + vimeoIframeID.attr( 'id' ) )[0];
                var vimPlayer = new Vimeo.Player( vimeoIframeObj );
                
                if ($(this).isInViewport()) {
                    
                    // If this video element is in view then play
                    vimPlayer.play();
                    
                }else{
                    
                    vimPlayer.pause();
                    
                }
                
            });
            
        }
        
    }

    function toggleVideoMute( objID, vidType ) {
        
        if( vidType == 'video'){
        
            var video = document.getElementById( objID );

            if(video.muted){
                video.muted = false;
                $('.toggleMute').addClass('toggleMuteOff');
            } else {
                video.muted = true;
                $('.toggleMute').removeClass('toggleMuteOff');
            }
            
        }

    }

    function animateGifsOnViewport(){
                
        $('.imageBgContainer').each(function(){
            var $div = $(this);	
            if ($div.isInViewport() && !$div.hasClass('animated')) {
                setTimeout(function(){
                    $div.addClass('firstAnimate animated');
                }, 1000);
                setTimeout(function(){
                    $div.removeClass('firstAnimate firstAnimateOngoing');
                }, 3000);
            }
        });
    }

    function mainCarousel() {

        //set hight on carousel
        var height = document.documentElement.clientHeight;

        var headerHeight = $('.topNav').height() + $('.mainNav').height();
        var controls = $('.carouselControlsHolder').height();

        if ($('#GalleryCarousel').hasClass('slick-slider')) {
            $('#GalleryCarousel').slick('unslick');
        }

        var carouselHeight = height - (headerHeight + controls);

        if ($('#GalleryCarouselHolder').data('full-page') == true) {
            $('#GalleryCarousel .carouselItem').css({'min-height': carouselHeight + "px"});
        }

        if ($('#GalleryCarousel').hasClass('slick-slider')) {
            $('#GalleryCarousel').slick('unslick');
        }

        $('#GalleryCarousel').slick({
            dots: true,
            infinite: false,
            arrows: true,
            speed: 1000,
            autoplaySpeed: 5000,
            autoplay: true,
            slidesToShow: 1,
            centerMode: false,
            appendDots: $('.carouselControlsHolder .dots'),
            appendArrows: $('.carouselControlsHolder .prevNext')
        });

    }

    function rotaterWidth() {
        var carouselHeight = $('.home-carousel').outerHeight() * 2;
        $('#rotateThis.slide0').css('width', (carouselHeight + 'px'));
    }  
    
    function viewport(){
        
        var e = window, a = 'inner';
            
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }

        return e[ a + 'Width' ];
        
    }
    
    /**
     * ========================
     * EXTERNAL SCOPE FUNCTIONS
     * ========================
     */
    
    /**
     * 
     * Detect the view port width (created as a function to help over-come the 'scope').
     * 
    */
    $.fn.viewPortDetect = function(){
        
        return {
            detectViewPort: function() {
            
                var e = window, a = 'inner';
            
                if (!('innerWidth' in window)) {
                    a = 'client';
                    e = document.documentElement || document.body;
                }
                
                return e[ a + 'Width' ];
                
            }            
        };                
        
    };
    
    $.HoverDir = function( options, element ) {
		
        this.$el = $( element );
        this._init( options );

    };

    // the options
    $.HoverDir.defaults = {
        speed : 300,
        easing : 'ease',
        hoverDelay : 0,
        inverse : false
    };

    $.HoverDir.prototype = {

        _init : function( options ) {

            // options
            this.options = $.extend( true, {}, $.HoverDir.defaults, options );
            // transition properties
            this.transitionProp = 'all ' + this.options.speed + 'ms ' + this.options.easing;
            // support for CSS transitions
            this.support = Modernizr.csstransitions;
            // load the events
            this._loadEvents();

        },
        _loadEvents : function() {

            var self = this;

            this.$el.on( 'mouseenter.hoverdir, mouseleave.hoverdir', function( event ) {

                var $el = $( this ),
                    $hoverElem = $el.find( 'div' ),
                    direction = self._getDir( $el, { x : event.pageX, y : event.pageY } ),
                    styleCSS = self._getStyle( direction );

                if( event.type === 'mouseenter' ) {

                    $hoverElem.hide().css( styleCSS.from );
                    clearTimeout( self.tmhover );

                    self.tmhover = setTimeout( function() {

                            $hoverElem.show( 0, function() {

                                var $el = $( this );
                                if( self.support ) {
                                    $el.css( 'transition', self.transitionProp );
                                }
                                self._applyAnimation( $el, styleCSS.to, self.options.speed );

                            } );


                    }, self.options.hoverDelay );

                }
                else {

                    if( self.support ) {
                        $hoverElem.css( 'transition', self.transitionProp );
                    }
                    clearTimeout( self.tmhover );
                    self._applyAnimation( $hoverElem, styleCSS.from, self.options.speed );

                }

            } );

        },

        _getDir : function( $el, coordinates ) {

            // the width and height of the current div
            var w = $el.width(),
                h = $el.height(),

                // calculate the x and y to get an angle to the center of the div from that x and y.
                // gets the x value relative to the center of the DIV and "normalize" it
                x = ( coordinates.x - $el.offset().left - ( w/2 )) * ( w > h ? ( h/w ) : 1 ),
                y = ( coordinates.y - $el.offset().top  - ( h/2 )) * ( h > w ? ( w/h ) : 1 ),

                // the angle and the direction from where the mouse came in/went out clockwise (TRBL=0123);
                // first calculate the angle of the point,
                // add 180 deg to get rid of the negative values
                // divide by 90 to get the quadrant
                // add 3 and do a modulo by 4  to shift the quadrants to a proper clockwise TRBL (top/right/bottom/left) **/
                direction = Math.round( ( ( ( Math.atan2(y, x) * (180 / Math.PI) ) + 180 ) / 90 ) + 3 ) % 4;

            return direction;

        },
        _getStyle : function( direction ) {

            var fromStyle, toStyle,
                    slideFromTop = { left : '0px', top : '-100%' },
                    slideFromBottom = { left : '0px', top : '100%' },
                    slideFromLeft = { left : '-100%', top : '0px' },
                    slideFromRight = { left : '100%', top : '0px' },
                    slideTop = { top : '0px' },
                    slideLeft = { left : '0px' };

            switch( direction ) {
                case 0:
                    // from top
                    fromStyle = !this.options.inverse ? slideFromTop : slideFromBottom;
                    toStyle = slideTop;
                    break;
                case 1:
                    // from right
                    fromStyle = !this.options.inverse ? slideFromRight : slideFromLeft;
                    toStyle = slideLeft;
                    break;
                case 2:
                    // from bottom
                    fromStyle = !this.options.inverse ? slideFromBottom : slideFromTop;
                    toStyle = slideTop;
                    break;
                case 3:
                    // from left
                    fromStyle = !this.options.inverse ? slideFromLeft : slideFromRight;
                    toStyle = slideLeft;
                    break;
            };

            return { from : fromStyle, to : toStyle };

        },
        // apply a transition or fallback to jquery animate based on Modernizr.csstransitions support
        _applyAnimation : function( el, styleCSS, speed ) {

            $.fn.applyStyle = this.support ? $.fn.css : $.fn.animate;
            el.stop().applyStyle( styleCSS, $.extend( true, [], { duration : speed + 'ms' } ) );

        }
    };
	
    var logError = function( message ) {

        if ( window.console ) {

                window.console.error( message );

        }

    };
	
    $.fn.hoverdir = function( options ) {

        var instance = $.data( this, 'hoverdir' );

        if ( typeof options === 'string' ) {

            var args = Array.prototype.slice.call( arguments, 1 );

            this.each(function() {

                if ( !instance ) {

                    logError( "cannot call methods on hoverdir prior to initialization; " +
                    "attempted to call method '" + options + "'" );
                    return;

                }

                if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {

                    logError( "no such method '" + options + "' for hoverdir instance" );
                    return;

                }

                instance[ options ].apply( instance, args );

            });

        } 
        else {

            this.each(function() {

                if ( instance ) {

                    instance._init();

                }
                else {

                    instance = $.data( this, 'hoverdir', new $.HoverDir( options, this ) );

                }

            });

        }

        return instance;

    };
    
    $('html').on('click', '.playVideo', function (e) {                
        
        e.preventDefault();
        e.stopPropagation();
        
        var videoID = $(this).attr('data-videoID');
        var defaultSubLang = $(this).attr('data-defaultSubLang');
                
        var defaultSubQStr = "";
        
        if(typeof $(this).attr('data-defaultSubLang') !== 'undefined'){
            defaultSubQStr = "&texttrack="+defaultSubLang;
        }
                        
        newPopup('videoPopup', '', '<iframe src="https://player.vimeo.com/video/' + videoID + '?title=0&byline=0&portrait=0' + defaultSubQStr + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
    
    });
    
    $('html').on('click', '.playLocalVideo', function (e) {                
        
        e.preventDefault();
        e.stopPropagation();
        
        var videoURL = $(this).attr('data-videoURL');
        var posterURL = $(this).attr('data-posterURL');
                        
//        newPopup('videoPopup', '', '<video id="genericLocalVideo" controlslist="nodownload" loop muted playsinline width="100%" height="auto" poster="' + posterURL + '">'
//                +'<source src="' + videoURL + '" type="video/mp4" />'
//                +'Your browser does not support the video tag.'
//                +'</video>');
        
        newPopup('videoPopup', '', '<iframe src="' + videoURL + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
    
    });
    
    $('html').on('click', '#popupMessage, #popupMessage iframe', function(e){
        disablePopup();
    });
    
    /**
     * POPUP Code
     */
    $( 'html' ).on( 'click', '#popupBackground', function(){
        disablePopup();
    });
	
    $(document).keypress(function(e){
        if(e.keyCode == 27 & popupStatus){
            disablePopup();
        }
    });
	
} )( jQuery, window );

function togglejobs(expandable) {
    expandable.slideToggle(400, function () {});
}
    
function noCache(href) {
    var now = new Date();
    if (href.indexOf('?') == -1) {
        href = href + '?';
    } else {
        href = href + '&';
    }
    return href + 'no-cache=' + now.getTime();
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                    results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// Displays a popup by COPYING the content, assigning a new ID and then displaying the popup
function popupMessage(type, title, content) {
    popup(type, title, jQuery(content).clone());
}

var popupStatus = null;
var thisContent = null;
function popup(type, title, content) {
	
    // Don't allow multiple popups
    if (popupStatus) {
        return;
    }

    thisContent = jQuery(content);
    popupStatus = content;

    jQuery('#popup').removeClass().addClass(type);
    jQuery('#popupType').html(type);
    jQuery('#popupTitle').html(title);
    jQuery('#popupMessage').empty();

    if (typeof(content) == 'string') {
            thisContent.appendTo('#popupMessage').show();
    } else {
            thisContent.detach().appendTo('#popupMessage').show();
    }

    //request data for centering
    var windowWidth = document.documentElement.clientWidth;
    var windowHeight = document.documentElement.clientHeight;
    var popupHeight = jQuery("#popup").height();
    var popupWidth = jQuery("#popup").width();

    //centering
    jQuery("#popup").css({
            "top": windowHeight/2-popupHeight/2,
            "left": windowWidth/2-popupWidth/2
    });

    //only need force for IE6

    jQuery("#popupBackground").css({
        "height": windowHeight
    });

    jQuery('#popupBackground').css({"opacity" : "0.5"}).fadeIn();
    jQuery('#popup').fadeIn();
}

function centrePopup() {
	
    //request data for centering
    var windowWidth = document.documentElement.clientWidth;
    var windowHeight = document.documentElement.clientHeight;
    var popupHeight = $("#popup").height();
    var popupWidth = $("#popup").width();

    jQuery("#popup").css({
        "top": windowHeight/2-popupHeight/2,
        "left": windowWidth/2-popupWidth/2
    });
    
}

function newPopup(type, title, content) {
    //disables popup only if it is enabled
    if(popupStatus){
        jQuery("#popupBackground").fadeOut('slow');
        jQuery("#popup").fadeOut('slow', function(){
            jQuery(popupStatus).remove();
            popupStatus = null;
            popup(type, title, content);
        });

    } else {
        popup(type, title, content);
    }
}

function disablePopup(){
	        
    //disables popup only if it is enabled
    if(popupStatus){
        jQuery("#popupBackground").fadeOut('slow');
        jQuery("#popup").fadeOut('slow', function(){jQuery(popupStatus).remove(); jQuery("#popup #popupMessage").empty(); popupStatus = null; });
    }
    
}

// Add listener for the Contact Form 7 plugin that check if the form has been submitted, if so hide it completely.
document.addEventListener('wpcf7mailsent', function( event ) {
    
    if( jQuery( '#experthide' ).length > 0 ){
        document.getElementById('experthide').style.display = 'none';
    }        
    
}, false );